// Vendor imports
const { combineReducers } = require('redux-immutable')
// Entry imports
const RootRecord = require('client-v2/logged-out-landing/state/record')

const reducers = {
  // Common state
  ...require('client-v2/common/state/reducers'),
  // Entry containers
  bannerSection: require('client-v2/logged-out-landing/containers/banner-section/reducer'),
  heroSection: require('client-v2/logged-out-landing/containers/hero-section/reducer')
}

module.exports = combineReducers(
  reducers,
  () => new RootRecord()
)
